
<div class="bottom-sheet">
    <div>{{ 'There are still' | translate }} {{data.unClosedChats}} {{ 'unapproved corrections' | translate }}</div>
    <button mat-raised-button type="button" #btnFocus cdkFocusInitial color="accent" (click)="approve()">{{ "Approve all corrections" | translate }}</button>
    <button mat-raised-button class="change" type="submit" color="primary" (click)="show()">{{ "Show corrections" | translate }}</button>
</div>